
export default {
  props: ["elements", "top10",'featured', "worth", "header"],
};
